import { routeConfig } from "@/router";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

const RouterPC = () => {
    const { pathname } = useLocation(); // 当前路由路径
    const { t } = useTranslation() // 国际化翻译函数
    const navigate = useNavigate(); // 路由导航函数
    // 解析路由配置，提取所有设置了 header 的页面路径与标题
    const headerShow = useMemo(() => {
        const result: any[] = [];

        // 遍历路由配置，收集 header 为 true 的节点
        const traverse = (nodes: any[]) => {
            for (const node of nodes) {
                if (node.header && node.path) {
                    result.push(node);
                }
                if (Array.isArray(node.children)) {
                    traverse(node.children);
                }
            }
        };

        traverse(routeConfig);
        const headerRoutes = Array.from(new Set(result));
        const headerPath = headerRoutes.map(item => item.path);
        const current = headerRoutes.find((item) => pathname === item.path);

        return { current, headerPath, headerRoutes };
    }, [pathname]);
    return (
        <div className="text-white hidden md:flex items-center ml-8">
            {headerShow.headerRoutes.map((item) => (
                <div
                    key={item.path}
                    onClick={() => {
                        navigate(item.path)
                    }}
                    className={`mx-4 cursor-pointer  ${pathname === item.path ? 'border-b-2 border-footBorder font-semibold  text-fa' : 'font-normal text-ad'}`}
                >
                    {t(item.headerTitle)}
                </div>
            ))}
        </div>
    )
}

export default RouterPC